export default "__VITE_ASSET__R05niy$S__"